// AUTO-GENERATED from environment.template.ts — do not edit by hand.

export const environment: {
  production: boolean;
  server: 'stage-branch' | 'stage-mirror' | 'dev' | 'live' | 'pre-live';
  sentry_dsn: string;
  branch: string;
  revision: string;
  release: string;
  release_url: string;
  backend_url: string;
  promo_url: string;
  api_url: string;
  materials_api_url: string;
  messaging_api_url: string;
  messaging_socket_url: string;
  messaging_socket_path: string;
  /** Feature flag: hides the Messages UI and skips the chat identity/socket bootstrap. */
  messaging_enabled: boolean;
  /** Dev-only: paste a Keycloak access token to bypass the in-app login for messaging. */
  messaging_dev_token?: string;
  teamcost_orchestrator_url: string;
  graphql_uri: string;
  images_path: string;
  maps_key: string;
  keycloak?: { url: string; realm: string; clientId: string };
} = {
  production: false,
  server: "dev",
  sentry_dsn: "https://428b30fb502c4caabc41181c7a6c6d6b@glitchtip.ops.beequeen.app/7",
  branch: "",
  revision: "",
  release: "",
  release_url: "",
  backend_url: "/@/backend",
  // No promo portal in The Hive — deployed builds send these links to the
  // BeeThere ambassador web app (MACS_FE_PROMO_URL).
  promo_url: "https://beethere.eu",
  api_url: "/@/backend/api/v1",
  materials_api_url: "/@/materials/api/v1",
  messaging_api_url: "/@/messaging/api/v1",
  messaging_socket_url: "https://messaging.dev.beethere.eu",
  messaging_socket_path: "/socket.io",
  // Disabled for the production launch (v1 scope) — flip to true to re-enable.
  messaging_enabled: true,
  // Deployed builds never use the dev token; set at runtime via localStorage in dev serves only.
  messaging_dev_token: '',
  teamcost_orchestrator_url: "/@/teamcost-orchestrator/api/v1/teamcost-orchestrator",
  graphql_uri: "/@/backend/graphql/",
  images_path: "/@/backend/uploads/",
  maps_key: "AIzaSyD3BSb_bws8mMLG85TKOeQE00znsYVG8DI",
  keycloak: {
    url: "https://auth.dev.beethere.eu",
    realm: "macs",
    clientId: "macs-spa",
  },
};
